<template>
  <div  v-if="finishedLoading">

	<!-- INICIO MODAL CANCELAR INVESTIMENTO -->
    <modal @close="voltar()" style="display:none;">
		<div slot="header">
			<div class="tit float-left">
				<h2>Cancelar investimento</h2>	
			</div>
		</div>
		<div slot="body">
			<!-- ÍNICIO BLOCO MOTIVO CANCELAMENTO -->
			<section class="row cancel-investiment">
				<div class="col-12">
					<h2>Tem certeza que deseja cancelar o seu investimento?</h2>
					<p>Sentimos muito que você esteja cancelando o seu investimento na oportunidade. Por favor, nos informe abaixo o motivo pelo qual está cancelando o seu investimento:</p>
				</div>
				<div class="col-12">
					<form class="row">
						<div class="col-12">
							<textarea name="" id="" rows="5"></textarea>
						</div>
						<div class="col-12">
							<button class="btn btn-lg btn-primary">Sim, desejo cancelar meu investimento</button>
							<button class="btn btn-lg btn-link">Não, irei manter meu investimento</button>
						</div>
						<div class="col-12 text-center" style="display:none;">
							<h2 style="margin: 60px 0;">Oferta de investimento cancelada.</h2>
						</div>
					</form>
				</div>
			</section>
			<!-- FINAL BLOCO MOTIVO CANCELAMENTO -->
		</div>
    </modal>
	<!-- FINAL MODAL INVESTIMENTO -->

    <div class="row company-view" :class="scoreClass" v-if="solicitacao != null">
      <div class="col-12">
        <div class="row tit_page">
          <div class="col-12">
            <div class="float-left">
              <h1>Oportunidade <span>id#{{id}}</span></h1>
            </div>
            <div class="back float-right">
              <router-link :to="'/investimentos/oportunidades'+voltarLink()" title="Voltar"><i>&nbsp;</i> voltar</router-link>
            </div>
            <div class="clearfix"></div>
            <hr class="divider">
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-8">
            <div class="tit">
              <div class="float-left">
                <h2>{{nomeFantasia}}</h2>
                <span>CNPJ: {{formattedCnpj}}</span>
                <small>{{formatarTipoEmprestimo(loanType)}}</small>              
              </div>
              <div class="rating float-left float-md-right">
                <strong>Score da operação <span class="circle score"></span> {{score}}</strong>
              </div>
              <div class="clearfix"></div>
            </div>

            <section>
              <at-tabs>
                <at-tab-pane label="Fotos" name="name1" icon="icon-camera">
                  <carousel :pictures="pictures"/>
                </at-tab-pane>
                <at-tab-pane label="Vídeo" name="name2" icon="icon-video">
                  <div class="row">
                    <div class="col-12">
                      <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" :src="vimeoVideoUrl" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                      </div>
                    </div>
                  </div>
                </at-tab-pane>
              </at-tabs>
              <div>
                
              </div>
              <h4 style="margin-top: 30px;">Descrição breve sobre a empresa</h4>
               <div v-html="companyDescription"></div>
            </section>

            <section>
              <h3>Dados da empresa</h3>

              <div class="row">
        
                <div class="col-12 col-lg-6">
                  <label>Empresa <span>(Razão social)</span></label>
                  <span>{{razaoSocial}}</span>
                </div>
                <div class="col-12 col-lg-3">
                  <label>CPF/CNPJ</label>
                  <span>{{formattedCnpj}}</span>
                </div>
                <div class="col-12 col-lg-3">
                  <label>Nome do responsável</label>
                  <span>{{nomeSolicitante}}</span>
                </div>
                <div class="col-12 col-lg-6">
                  <label>Nome fantasia</label>
                  <span>{{nomeFantasia}}</span>
                </div>
                <div class="col-12 col-lg-6">
                  <label>Telefone comercial</label>
                  <span>{{telefoneComercial}}</span>
                </div>  
                <div class="col-12 col-lg-3">
                  <label>Data de fundação</label>
                  <span>{{dataFundacao}}</span>
                </div>  
                <div class="col-12 col-lg-3">
                  <label>Número de funcionários</label>
                  <span>{{quantidadeEmpregados}} empregados</span>
                </div>
                <div class="col-12 col-lg-6">
                  <label>Nome do grupo ecônomico</label>
                  <span>{{nomeGrupoEconomico}}</span>
                </div>  
                <div class="col-12">
                  <label>Endereço</label>
                  <span>{{address}}</span>
                </div>
                <div class="col-12 col-lg-5">
                  <label>Site</label>
                  <span>{{site}}</span>
                </div>
                <div class="col-12 col-lg-7">
                  <label>Redes Sociais</label>
                  <span>
                    <a v-if="companyFacebook" :href="companyFacebook" class="fab fa-facebook-square"></a>
                    <a v-if="companyTwitter" :href="companyTwitter" class="fab fa-twitter"></a>
                    <a v-if="companyLinkedin" :href="companyLinkedin" class="fab fa-linkedin-in"></a>
                    <a v-if="companyInstagram" :href="companyInstagram" class="fab fa-instagram"></a>
                    <a v-if="companyVimeo" :href="companyVimeo" class="fab fa-vimeo-v"></a>
                  </span>
                </div>
               
                <div class="col-12" v-if="formatoInvestimento">
                  <div class="alert alert-secondary" role="alert">
                    <strong>Formato do Investimento:</strong>  {{formatoInvestimento}}
                  </div>
                </div>                                    
              </div>

              <iframe :src="mapUrl" width="100%" height="280" frameborder="0" style="border:0; border-radius:5px;" allowfullscreen></iframe>

              <div>
                <h4>Motivo da solicitação do empréstimo</h4>
                <p>{{motivoSolicitacao}}</p>
              </div>

              <div>
                <h4>Garantias oferecidas</h4>
                <p>{{garantiasOferecidas}}</p>              
              </div>


              <h4>Índices financeiros</h4>

              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="box">
                    <label>Faturamento anual</label>
                    <p>R$ {{faturamentoAnual}}</p>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="box">
                    <label>Lucro líquido mensal</label>
                    <p>R$ {{lucroLiquido}}</p>
                  </div>
                </div>
                <div class="col-12 col-xl-6">
                  <div class="box">
                    <div class="row no-gutters">
                      <div class="col-12 col-md-6">
                        <label>Endividamento</label>
                        <p>{{divida}}</p>
                      </div>
                      <div class="col-12 col-md-6">
                        <label>Data base da consulta</label>
                        <p>{{dataConsultaEndividamento}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-xl-6">
                  <div class="box">
                    <div class="row no-gutters">
                      <div class="col-12 col-md-6">
                        <label>Negativações</label>
                        <p>{{negativacoes}}</p>
                      </div>
                      <div class="col-12 col-md-6">
                        <label>Atrasos/restritivos <span>(90 dias)</span></label>
                        <p>R$ {{atrasos}}</p>
                      </div>
                    </div>
                  </div>
                </div>              
                <div class="col-12 col-lg-12">
                  <div class="box box_chart">
                    <h2>Faturamento dos últimos 12 meses</h2>
                    <bar-chart :data="chartData"/>
                  </div>
                </div>                              
              </div>
            </section>
            <section>
              <h3>Análise sobre a empresa</h3>
              <div class="em-analise" v-html="analiseEmpresa"></div>
            </section>
          </div>

          <aside class="col-12 col-lg-4">
            <investment-reservation-form :loan-request="solicitacao" :sDisponivel="this.sDisponivel"  :investment-confirmed="this.investmentConfirmed" @submit="submitInvestment"/>
          </aside>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
 @import "../assets/styles/iouu/mixins";

  .carousel-item {
    img {
      border-radius: 5px;
    }
  }

  @include sm {

    .tit_page {

      h1 {
        &{
          font-size: calcRem(30);
        }

        span {
          font-size: 1rem;
        }
      }

      .back {
        display: none;
      }
    }

    .tit {
      h2 {
        font-size: calcRem(20);
      }
    }

    .company-view {
      section {
        h3 {
          font-size: calcRem(20);
        }

        h2 {
          font-size: calcRem(22);
        }

        span {
          font-size: calcRem(18);
        }
      }
    }
  }

  @include xs {

    .tit_page {

      h1 {
        &{
          font-size: calcRem(20);
        }

        span {
          font-size: calcRem(14);
          padding-left: calcRem(10);
          margin-left: calcRem(10);
          line-height: calcRem(45);
          background-size: 6px;
        }
      }

      .back {
        display: none;
      }
    }

    .tit {
      h2 {
        font-size: calcRem(18);
      }

      span {
        font-size: 1rem;
      }
    }

    .company-view {
      section {
        h3 {
          font-size: calcRem(20);
        }

        h2 {
          font-size: calcRem(22);
        }

        span {
          font-size: calcRem(13);
        }
      }
    }

    .box_chart {
      &{
        display: none;
      }
    }
  }
</style>

<script>
import ApiClient from '../utils/api-client'
import * as mutationTypes from '@/store/mutation-types.js'
import BarChart from '@/components/charts/BarChart'
import Carousel from '@/components/Carousel'
import Masker from '@/utils/masker'
import ArrayHelper from '@/utils/array-helper'
import InvestmentReservationForm from '@/components/CompanyProfile/InvestmentReservationForm'
// import Promise from 'promise'

export default {
  components: { BarChart, Carousel, InvestmentReservationForm },
  data() {
    return {
      finishedLoading: false,
      solicitacao: {
        ValorCaptado: null,
        QuantidadeReservasInvestimento: null
      },
      investmentReservation: null,
      googleMapsKey: this.$config.googleApi.googleMapsKey,
      showQueueForm: false,
      minPercentToQueue: this.$config.investment.minPercentToQueue,
      investmentConfirmed: false,
      sDisponivel : 0,
    }
  },
 
  computed: {
    id: function() {return this.ajustIdOportunidade(this.solicitacao.IdOportunidade,5)},
    company: function() { return this.solicitacao.Empresa },
    nomeFantasia: function() {return this.company && this.company.NomeFantasia},
    razaoSocial: function() {return this.company && this.company.RazaoSocial},
    formattedCnpj: function() {return Masker.maskCnpj(this.solicitacao.Documento)},
    loanType: function() {return this.solicitacao.TipoEmprestimo},
    scoreClass: function() {
      if(!this.solicitacao.Score ) return ""
      return "rating-" + this.solicitacao.Score.replace(/\d/, '').toLowerCase()
    },
    score: function() { return this.solicitacao.Score },
    companyDescription: function() { return this.company && this.company.InformacaoInstitucional },
    telefoneComercial: function() { return this.solicitacao.TelefoneComercial },
    dataFundacao: function() { return this.company && this.company.DataFundacao.toLocaleDateString('pt-BR') },
    quantidadeEmpregados: function() { return this.company && this.company.QuantidadeEmpregados },
    nomeGrupoEconomico: function() {
      if(!this.company) return null
      return this.company.NomeGrupoEconomico != "" ? this.company.NomeGrupoEconomico : 'Não pertence a nenhum grupo econômico'
    },
    address: function() {
      if(!this.company) return null
      const  address = this.company.Endereco
      const complement = this.company.Endereco.Complemento && this.company.Endereco.Complemento.length > 0 ?  " - " + this.company.Endereco.Complemento : ""
      return `${address.Logradouro}, ${address.Numero}${complement}, ${address.Bairro} - ${address.Cep}, ${address.Cidade}/${address.Uf}`
    },
    motivoSolicitacao: function() {return this.solicitacao.Motivo},
    garantiasOferecidas: function() {
      
      return this.solicitacao.TipoGarantia != "" ? this.solicitacao.TipoGarantia : "Não possui nenhum tipo de garantia"
    },
    faturamentoAnual: function() {
      if(!this.solicitacao) return null
      return this.formatCurrency(this.solicitacao.Faturamento)
    },
    lucroLiquido: function() {
      if(!this.company) return null
      return this.formatCurrency(this.company.LucroMensal)
    },
    divida: function() {
      return this.company.ValorDividaBancaria != 0 ? "R$ " + this.formatCurrency(this.company.ValorDividaBancaria) : "Nada consta"
    },
    dataConsultaEndividamento() {
      const date = this.company.DataConsultaEndividamento
      
      return this.company.DataConsultaEndividamento ? `${(date.getMonth()+1).toString().padStart(2, "0")}/${date.getFullYear()}` : ""
    },
    analiseEmpresa() {
      return this.solicitacao.AnaliseEmpresa
    },
    nomeSolicitante() {
      return this.solicitacao.Solicitante.NomeCompleto
    },
    chartData() {
      return this.company.FaturamentoDozeMeses.map(item => {
        return {
            label: item.Mes.slice(0,3)+"/"+item.Ano.toString().slice(2,4), 
            value: item.Valor 
          }
      })
    },
    site() { return this.company.Site },
    mapUrl() {
      return `https://www.google.com/maps/embed/v1/place?q=${this.address}&key=${this.googleMapsKey}`
    },
    companyFacebook() { return this.solicitacao.Empresa.Facebook },
    companyTwitter() { return this.solicitacao.Empresa.Twitter },
    companyLinkedin() { return this.solicitacao.Empresa.Linkedin },
    companyInstagram() { return this.solicitacao.Empresa.Instagram },
    companyVimeo() { return this.solicitacao.Empresa.Vimeo },
    formatoInvestimento(){ return this.solicitacao.FormatoInvestimento },
    negativacoes() { return this.solicitacao.Empresa.Negativacoes || "Nada consta" },
    atrasos() { return this.formatCurrency(this.solicitacao.Empresa.Atrasos) || "0,00"},
    pictures() {
      return this.solicitacao.Empresa.Imagens
    },
    vimeoVideoUrl() { return this.solicitacao.Empresa.VimeoVideoUrl }
  },
  methods: {
    formatarTipoEmprestimo(tipoEmprestimo) {

      if(tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2"){
        return "Impacto";
      }

      var splitedTipoEmprestimo = tipoEmprestimo.split('-');

      if(splitedTipoEmprestimo.length > 1) {
        return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
      }

      return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);      
    },
     ajustIdOportunidade(id, qtd) {
      var s = String(id);
      while (s.length < (qtd || 2)) {
        s = "0" + s;
      }
      return s;
    },
    submitInvestment(investmentReservation) {
      if(!investmentReservation._id && this.investmentReservation)
        investmentReservation._id = this.investmentReservation._id;

      if(investmentReservation._id) {
        ApiClient.updateInvestmentReservation(investmentReservation)
          .then(() => {
            setTimeout(() => this.updateLoanRequest(), 500)
            this.investmentConfirmed = true;
            this.$store.dispatch('updateUser')
          })
          .catch(error => {
            const errorMessages = error.response ? error.response.data.errors.map(error => error.detail) : error.message
            this.$Notify.error(ArrayHelper.toSentence(errorMessages))
            this.investmentConfirmed = false;
          })
      } else {

        ApiClient.createInvestmentReservation({
          loanRequestId: this.solicitacao._id,
          investmentReservation: investmentReservation
        })
        .then(() => {
          setTimeout(() => this.updateLoanRequest(), 500);
          this.investmentConfirmed = true;
          this.$store.dispatch('updateUser')
        })
        .catch(error => {
          const errorMessages = error.response ? error.response.data.errors.map(error => error.detail) : error.message
          this.$Notify.error(ArrayHelper.toSentence(errorMessages))
          this.investmentConfirmed = false;
        })
      }
    },
    formatCurrency(value) {

      if(value == null || value == undefined )
        return parseFloat(0).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})

      return value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})
    },
    updateLoanRequest() {
      return ApiClient.getLoanRequest(this.solicitacaoId)
        .then(loanRequest => {
          this.solicitacao = loanRequest;

          ApiClient.getInvestmentReservation({ loanRequestId: this.solicitacaoId })
          .then(investmentReservation => {
            this.investmentReservation = investmentReservation || { Valor: 0 };
          });
        })
    },
    voltarLink()
      {
        var separador = window.location.href.split("#")
        if(separador.length > 2)
        {
          return "#"+ separador[2];
        }
          
        return ""
      },
    diffDate(d1, d2) {
      var miliSecs = 0

      if(d1 == "")
      miliSecs =(new Date(d2)) - (new Date())
      else
      miliSecs =(new Date(d2)) - (new Date(d1))

      const  diffDays =  Number.parseInt(miliSecs/1000/60/60/24)

      if (diffDays < 0) return "encerrado";
      if (diffDays == 0) return "hoje";

      return diffDays + " dias";
    },

    //tagueamento GA
    taggingGA() {
      this.$ga.page({
        page: '/oportunidades/perfil-empresa-old/:id',
        title: 'Empresa',
      })
    },
  },
  beforeCreate() {
    this.$store.dispatch('updateUser')
  },
  async created() {
    this.solicitacaoId = this.$route.params.id

    if(typeof this.$store.state.currentUser.investor.Bloqueio != 'undefined'){
      window.location.href="#/";
    }
    
    //ajuste modal
    if(document.getElementsByTagName("main").length > 0)
     document.getElementsByTagName("main")[0].style.zIndex = "0";

      this.$store.commit(mutationTypes.START_LOADING)
    

     


    ApiClient.getInvestmentReservation({loanRequestId: this.solicitacaoId})
      .then(investmentReservation => {
        this.investmentReservation = investmentReservation;
        if(investmentReservation != null)
        this.investmentConfirmed = true;



      ApiClient.getMyAvalibleMoney()
      .then(item => {

          item.data.credito = (item.data.credito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
          var credito =  parseFloat(item.data.credito) ;

          item.data.debito = (item.data.debito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
          var debito =  parseFloat(item.data.debito) ;

          this.sDisponivel = credito - debito;
          this.sDisponivel = parseFloat(this.sDisponivel.toFixed(2));
          
          if(this.sDisponivel < 0.01)
          {
            this.sDisponivel = 0;
          }

          if(this.investmentReservation != null && this.investmentReservation.ReInvestimento > 0){
              this.sDisponivel += this.investmentReservation.ReInvestimento
            }

      });




      })

     var x = ApiClient.getLoanRequest(this.solicitacaoId)
        .then(loanRequest => {
          this.solicitacao = loanRequest;

          loanRequest.Encerrado = loanRequest.StatusAnalise == "ENCERRADO" || this.diffDate("", loanRequest.FimCaptacao) == "encerrado"; 

          this.solicitacao = loanRequest;
        })

        x.then(()=>{
        this.finishedLoading = true
        this.$store.commit(mutationTypes.STOP_LOADING)

        }).catch(()=>{
          this.finishedLoading = true
        this.$store.commit(mutationTypes.STOP_LOADING)
        });

    //tagueamento GA
    await this.taggingGA();
  },
}
</script>




// WEBPACK FOOTER //
// src/views/CompanyProfileOld.vue